import { render, staticRenderFns } from "./Stats1.container.vue?vue&type=template&id=735e8622&scoped=true&"
import script from "./Stats1.container.vue?vue&type=script&lang=js&"
export * from "./Stats1.container.vue?vue&type=script&lang=js&"
import style0 from "./Stats1.container.vue?vue&type=style&index=0&id=735e8622&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735e8622",
  null
  
)

export default component.exports